import React, { useState } from 'react';
import {
    Modal, Table, Button, Header, Icon, Popup
} from 'semantic-ui-react';
import Form from './Form';
import Dimmer from '+/Dimmer';
import Swal from '#/swal';

import { useDeleteDocument, useFetchDocuments } from '~/documents';

const docPath = doc => {
    const url = new URL(`/documents/${doc.name}/download`, process.env.REACT_APP_API_URL);

    return url.href;
};

const ListDocuments = props => {

    const { data, isFetching } = useFetchDocuments();
    const { mutate: deleteDocument } = useDeleteDocument();

    const [modalOpen, setModalOpen] = useState(false);
    const [initialValues, setInitialValues] = useState(null);

    const booleanIcons = value => {
        if (value) return <Icon name='check circle' color='green' size='large' />;

        return <Icon name='times circle' size='large' color='red'/>;
    };

    const handleDeleteDocument = async documentId => {
        const { value } = await Swal.fire.warning();
        if (value) deleteDocument(documentId);
    };

    if (!data || isFetching) return <Dimmer message='Fetching matrix, this can take up to 30 seconds' />;

    return (
        <div style={styles.root}>

            <div style={styles.header}>
                <div style={styles.subHeader}>
                    <Header
                        as='h2'
                        content='Legal Documents'
                        color='grey'
                        className='no-margin sm-padding-right'
                    />
                    <Popup
                        content='Click to view template aliases'
                        trigger={<Icon name='help circle'
                            onClick={() => props.history.push('/documents/help')}/>}
                    />
                </div>
                <div>
                    <Button
                        primary
                        compact
                        floated='right'
                        icon='add'
                        content='New Document'
                        onClick={() => {
                            setInitialValues(null);
                            setModalOpen(true);
                        }}
                    />
                </div>
            </div>

            <Table celled compact singleLine columns={5}>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Name</Table.HeaderCell>
                        <Table.HeaderCell>Filename</Table.HeaderCell>
                        <Table.HeaderCell>Requires Notary</Table.HeaderCell>
                        <Table.HeaderCell>Requires Lawyer</Table.HeaderCell>
                        <Table.HeaderCell textAlign='center'>Actions</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {
                        data
                && data.map((doc, i) => (
                    <Table.Row key={i}>
                        <Table.Cell content={doc.description} />
                        <Table.Cell content={doc.name} />
                        <Table.Cell content={booleanIcons(doc.requires_notary)} />
                        <Table.Cell content={booleanIcons(doc.requires_lawyer)} />
                        <Table.Cell textAlign='center'>

                            <Button
                                compact
                                size='small'
                                positive
                                icon='download'
                                content='Download'
                                onClick={
                                    () => window.open(docPath(doc), '_blank')}
                            />
                            <Button
                                compact
                                size='small'
                                icon='edit'
                                content='Edit'
                                onClick={() => {
                                    setInitialValues(doc);
                                    setModalOpen(true);
                                }}
                            />
                            <Button
                                compact
                                size='small'
                                color='red'
                                icon='delete'
                                content='Delete'
                                onClick={() => handleDeleteDocument(doc.id)}
                            />

                        </Table.Cell>
                    </Table.Row>
                ))
                    }
                </Table.Body>

            </Table>

            <Modal size='small' open={modalOpen} >
                <Modal.Header content='New Document' />
                <Modal.Content>
                    <Form setModalOpen={setModalOpen} initialValues={initialValues}/>
                </Modal.Content>
            </Modal>

        </div>
    );
};

const styles = {
    subHeader: {
        display: 'flex',
        alignItems: 'center'
    },
    root: {
        marginLeft: '10px',
        marginRight: '10px'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: '10px',
        alignItems: 'center',
        paddingTop: '20px'
    }
};

export default ListDocuments;
